import React, { useEffect, useRef, useState } from 'react'
import ModalComponent from '../../../../../core/common/modal/ModalComponent'
import PhotographyRelease from './PhotographyRelease'
import { useFormik } from 'formik';
import { useGetprintoutPdfDetailsQuery, useLazyGetTeamMembersEmailQuery, useLazyGetTemplatesQuery, useSendEmailMutation } from '../../../../../services/EndPointsApis';
import * as Yup from "yup";
import { toast } from 'react-toastify';
import RichTextEditor from '../../../../../core/common/Rich Text Editor/RichTextEditor';
import { customStyles } from '../../../../../core/common/Custom Style/CustomStyle';
import TextField from '../../../../../core/common/textFields/TextField';
import Select from "react-select";
import RecoAlreadySoldJob from './RecoAlreadySoldJob';
import RecoDanialLetter from './RecoDanialLetter';
import RecoDuplicateReflLetter from './RecoDuplicateReference';
import RecoJobInConstructionWithCheck from './RecoJobInConstructionwithCheck';
import RecoJobInConstruction from './RecoJobInConstruction';
import RecoJobSoldLetter from './RecoJobSold';
import RecoNoPhoneNumber from './RecoNoPhoneNumber';
import RecoPaymentLetter from './RecoPaymentLetter';
import RecoReceiveLetter from './RecoReceiveLetter';
import { useReactToPrint } from 'react-to-print';
import ImageWithBasePath from '../../../../../core/common/imageWithBasePath';
import html2pdf from 'html2pdf.js';

const MarketingTemplates = ({ projectId, projectLookups }: any) => {
    const [showModalPhotography, setShowModalPhotography] = useState(false);
    const [showModalRecoAlready, setShowModalRecoAlready] = useState(false);
    const [showModalRecoDenial, setShowModalRecoDenial] = useState(false);
    const [showModalRecoDuplicateRef, setShowModalRecoDuplicateRef] = useState(false);
    const [showModalJobInWithCheck, setShowModalJobInWithCheck] = useState(false);
    const [showModalJobInConst, setShowModalJobInConst] = useState(false);
    const [showModalRecoJobSold, setShowModalRecoJobSold] = useState(false);
    const [showModalRecoNoPhone, setShowModalRecoNoPhone] = useState(false);
    const [showModalRecoPaymentLetter, setShowModalRecoPaymentLetter] = useState(false);
    const [showModalRecoReceivedLetter, setShowModalRecoReceivedLetter] = useState(false);



    const [templateId, setShowTemplateId] = useState('')
    const [fileNamePopup, setFileNamePopup] = useState('')

    //templates Api

    const [triggerTemplates, { data: templatesData }] = useLazyGetTemplatesQuery()
    const { data: printOutPdfDetails, refetch: refetchPrintOutPdf } =
        useGetprintoutPdfDetailsQuery({ ProjectId: projectId });



    const handleShowModalPhotography = (templateName: string, modalTitle: string, fileName: string) => {
        setShowModalPhotography(true)
        setShowTemplateId(templateName)
        setModalTitlePopup(modalTitle)
        setFileNamePopup(fileName)
    }
    const handleShowModalRecoAlready = (templateName: string, modalTitle: string, fileName: string) => {
        setShowTemplateId(templateName)
        setModalTitlePopup(modalTitle)
        setFileNamePopup(fileName)
        setShowModalRecoAlready(true)
    }
    const handleShowModalRecoDenial = (templateName: string, modalTitle: string, fileName: string) => {
        setShowTemplateId(templateName)
        setModalTitlePopup(modalTitle)
        setFileNamePopup(fileName)
        setShowModalRecoDenial(true)
    }
    const handleShowModalRecoDuplicateRef = (templateName: string, modalTitle: string, fileName: string) => {
        setShowTemplateId(templateName)
        setModalTitlePopup(modalTitle)
        setFileNamePopup(fileName)
        setShowModalRecoDuplicateRef(true)
    }
    const handleShowModalRecoJobIn = (templateName: string, modalTitle: string, fileName: string) => {
        setShowTemplateId(templateName)
        setModalTitlePopup(modalTitle)
        setFileNamePopup(fileName)
        setShowModalJobInConst(true)
    }
    const handleShowModalRecoJobInWithCheck = (templateName: string, modalTitle: string, fileName: string) => {
        setShowTemplateId(templateName)
        setModalTitlePopup(modalTitle)
        setFileNamePopup(fileName)
        setShowModalJobInWithCheck(true)
    }
    const handleShowModalRecoJobSold = (templateName: string, modalTitle: string, fileName: string) => {
        setShowTemplateId(templateName)
        setModalTitlePopup(modalTitle)
        setFileNamePopup(fileName)
        setShowModalRecoJobSold(true)
    }
    const handleShowModalRecoNoPhone = (templateName: string, modalTitle: string, fileName: string) => {
        setShowTemplateId(templateName)
        setModalTitlePopup(modalTitle)
        setFileNamePopup(fileName)
        setShowModalRecoNoPhone(true)
    }
    const handleShowModalRecoPayLetter = (templateName: string, modalTitle: string, fileName: string) => {
        setShowTemplateId(templateName)
        setModalTitlePopup(modalTitle)
        setFileNamePopup(fileName)
        setShowModalRecoPaymentLetter(true)
    }
    const handleShowModalRecoRecLetter = (templateName: string, modalTitle: string, fileName: string) => {
        setShowTemplateId(templateName)
        setModalTitlePopup(modalTitle)
        setFileNamePopup(fileName)
        setShowModalRecoReceivedLetter(true)
    }


    const handleClosePhotography = () => {
        setShowModalPhotography(false)
    }
    const handleCloseRecoAlready = () => {
        setShowModalRecoAlready(false)
    }
    const handleCloseRecoDenial = () => {
        setShowModalRecoDenial(false)
    }
    const handleCloseRecoDuplicateRef = () => {
        setShowModalRecoDuplicateRef(false)
    }
    const handleCloseRecoJobInWithCheck = () => {
        setShowModalJobInWithCheck(false)
    }
    const handleCloseRecoJobInConst = () => {
        setShowModalJobInConst(false)
    }
    const handleCloseRecoJobSold = () => {
        setShowModalRecoJobSold(false)
    }
    const handleCloseRecoNoPhone = () => {
        setShowModalRecoNoPhone(false)
    }
    const handleCloseRecoPayLetter = () => {
        setShowModalRecoPaymentLetter(false)
    }
    const handleCloseRecoReceiveLetter = () => {
        setShowModalRecoReceivedLetter(false)
    }


    const initiateDownloadPhotography = (blobData: Blob) => {
        const url = window.URL.createObjectURL(blobData);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileNamePopup);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        setShowModalPhotography(false);
    };

    const downloadhandlePhotography = async () => {
        try {
            // Trigger the query and unwrap the response
            const photographyData = await triggerTemplates({ projectId: projectId, TemplateName: templateId }).unwrap();

            if (!photographyData) {
                console.error("No data received for binder cover download.");
                return;
            }

            // Ensure the response is a Blob
            if (!(photographyData instanceof Blob)) {
                console.error("Expected a Blob but received:", photographyData);
                return;
            }

            // Proceed with download
            initiateDownloadPhotography(photographyData);
            setShowTemplateId('');


        } catch (error) {
            console.error("Error downloading file:", error);
        }
    };

    const [showEmailModal, setShowEmailModal] = useState(false);

    //email api
    const [sendEmail, { data, isSuccess }] = useSendEmailMutation();
    //getTeam Member Email
    const [
        triggerTeamsMember,
        { data: getTeamMembers, isSuccess: isSuccessEmail, isFetching },
    ] = useLazyGetTeamMembersEmailQuery();

    const [emails, setEmails] = useState<string[]>([]);
    const [inputValue, setInputValue] = useState("");
    const [fileData, setFileData] = useState<File[]>([]);
    const [modalTitlePopup, setModalTitlePopup] = useState("");

    const isValidEmail = (email: string) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const decodeHtml = (html: any) => {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    };
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter" && inputValue.trim()) {
            e.preventDefault();
            const email = inputValue.trim();

            if (
                isValidEmail(email) &&
                !formik.values.ExternalEmailAddresses.includes(email)
            ) {
                formik.setFieldValue("ExternalEmailAddresses", [
                    ...formik.values.ExternalEmailAddresses.filter(
                        (email: string) => email !== ""
                    ),
                    email,
                ]);
                setInputValue("");
            }
        }
    };
    const removeEmail = (email: string) => {
        const filteredEmails = formik.values.ExternalEmailAddresses.filter(
            (e: string) => e !== email
        );
        formik.setFieldValue("ExternalEmailAddresses", filteredEmails);
    };
    const handleClose = () => {
        setShowEmailModal(false);
        formik.resetForm();
    };

    const handleSave = () => {
        formik.handleSubmit();
    };
    const handleGetTeamMembers = () => {
        triggerTeamsMember({ projectId: projectId });
    };

    const ValidationSchema = Yup.object().shape({
        Subject: Yup.string().required("Subject is required"),
        InternalEmailAddresses: Yup.array()
            .of(
                Yup.object().shape({
                    id: Yup.number()
                        .min(1, "Internal User required")
                        .required("Internal User required"),
                })
            )
    });

    const initialValues = {
        Subject: "",
        InternalEmailAddresses: [
            {
                id: 0,
                value: "",
            },
        ],
        ExternalEmailAddresses: [""],
        Body: "",
        Attachments: [] as { name: string; data: ArrayBuffer }[],
    };

    const formik = useFormik({
        initialValues,
        validationSchema: ValidationSchema,
        onSubmit: async (values) => {
            const formData = new FormData();
            formData.append("Subject", values.Subject);
            formData.append(
                "InternalEmailAddresses",
                values.InternalEmailAddresses.map((item) => item.value).toString()
            );
            formData.append(
                "ExternalEmailAddresses",
                values.ExternalEmailAddresses.toString()
            );
            formData.append("Body", values.Body);
            values.Attachments.forEach(({ name, data }, index) => {
                const fileBlob = new Blob([data], { type: "application/pdf" });
                formData.append(`Attachments`, fileBlob, name);
            });
            try {
                await sendEmail(formData).unwrap();
                toast.success("Email Sent successfully");
                formik.resetForm();
                setShowEmailModal(false);
            } catch (error) {
                console.error("Error uploading file:", error);
            }
        },
    });

    const selectValues = formik.values?.InternalEmailAddresses
        ? formik.values.InternalEmailAddresses.filter(
            (users: { id: number; value: string }) =>
                users.id !== 0 && users.value !== ""
        ).map((users: { id: number; value: string }) => ({
            value: users?.id,
            label: users?.value,
        }))
        : [];

    const handleChange = (newValue: any) => {
        const updatedValues = newValue.map(
            (option: { value: any; label: any }) => ({
                id: option.value,
                value: option.label,
            })
        );

        formik.setFieldValue("InternalEmailAddresses", updatedValues);
    };

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files && files.length > 0) {
            const fileArray = Array.from(files);
            setFileData(fileArray);
            formik.setFieldValue("Attachments", fileArray);
        }
    };

    useEffect(() => {
        if (!isFetching && getTeamMembers?.result) {
            console.log(getTeamMembers);

            const mappedMembers = getTeamMembers.result.map((member: any) => ({
                id: member.id,
                value: member.value,
            }));

            setEmails(mappedMembers);
            formik.setFieldValue("InternalEmailAddresses", mappedMembers);
        }
    }, [isFetching, getTeamMembers]);

    const handleEmailWithTemplate = async (templateName: string, modalTitle: string, fileName: string) => {
        setModalTitlePopup(modalTitle);
        setShowEmailModal(true);
        if (templateName === 'PhotographyRelease') {
            setShowModalPhotography(false);
        }
        if (templateName === 'RecoAlreadySoldJobLetter') {
            setShowModalRecoAlready(false);
        }
        if (templateName === 'RecoDenialLetter') {
            setShowModalRecoDenial(false);
        }
        if (templateName === 'RecoDuplicateReferralLetter') {
            setShowModalRecoDuplicateRef(false);
        }
        if (templateName === 'RecoJobInConstructionLetter') {
            setShowModalJobInConst(false);
        }
        if (templateName === 'RecoJobInConstructionLetterwithCheckRequisition') {
            setShowModalJobInWithCheck(false);
        }
        if (templateName === 'RecoJobSoldLetter') {
            setShowModalRecoJobSold(false);
        }
        if (templateName === 'RecoNoPhoneNumberLetter') {
            setShowModalRecoNoPhone(false);
        }
        if (templateName === 'RecoPaymentLetter') {
            setShowModalRecoPaymentLetter(false);
        }
        if (templateName === 'RecoReceivedLetter') {
            setShowModalRecoReceivedLetter(false);
        }

        try {
            const templatesData = await triggerTemplates({ projectId, TemplateName: templateName }).unwrap();
            const arrayBuffer = await templatesData.arrayBuffer();

            formik.setFieldValue("Attachments", [
                { name: fileName, data: arrayBuffer },
            ]);

        } catch (error) {
            console.error("Failed to load template:", error);
        }
    };

    //print for Photography release
    const [shouldPrintPhotgraphy, setShouldPrintPhotgraphy] = useState(false);
    const printRefPhotgraphy = useRef(null);

    const handlePrintRefPhotgraphy = useReactToPrint({
        content: () => printRefPhotgraphy.current,
    });

    const handlePrintPhotgraphy = () => {
        setShouldPrintPhotgraphy(true);
    };

    const handlePhotgraphy = () => {
        if (shouldPrintPhotgraphy) {
            handlePrintRefPhotgraphy();
            setShouldPrintPhotgraphy(false);
        }
    };
    //print for Reco Sold 
    const [shouldPrintRecoSold, setShouldPrintRecoSold] = useState(false);
    const printRefRecoSold = useRef(null);

    const handlePrintRefRecoSold = useReactToPrint({
        content: () => printRefRecoSold.current,
    });

    const handlePrintRecoSold = () => {
        setShouldPrintRecoSold(true);
        refetchPrintOutPdf()
    };

    const handleRecoSold = () => {
        if (shouldPrintRecoSold) {
            handlePrintRefRecoSold();
            setShouldPrintRecoSold(false);
        }
    };
    //print for Danial Letter
    const [shouldPrintDanial, setShouldPrintDanial] = useState(false);
    const printRefDanial = useRef(null);

    const handlePrintRefDanial = useReactToPrint({
        content: () => printRefDanial.current,
    });

    const handlePrintDanial = () => {
        setShouldPrintDanial(true);
        refetchPrintOutPdf()
    };

    const handleDanial = () => {
        if (shouldPrintDanial) {
            handlePrintRefDanial();
            setShouldPrintDanial(false);
        }
    };
    //print for Duplicate Letter
    const [shouldPrintDuplicate, setShouldPrintDuplicate] = useState(false);
    const printRefDuplicate = useRef(null);

    const handlePrintRefDuplicate = useReactToPrint({
        content: () => printRefDuplicate.current,
    });

    const handlePrintDuplicate = () => {
        setShouldPrintDuplicate(true);
        refetchPrintOutPdf()
    };

    const handleDuplicate = () => {
        if (shouldPrintDuplicate) {
            handlePrintRefDuplicate();
            setShouldPrintDuplicate(false);
        }
    };
    //print for Construction Letter
    const [shouldPrintConstruction, setShouldPrintConstruction] = useState(false);
    const printRefConstruction = useRef(null);

    const handlePrintRefConstruction = useReactToPrint({
        content: () => printRefConstruction.current,
    });

    const handlePrintConstruction = () => {
        setShouldPrintConstruction(true);
        refetchPrintOutPdf()
    };

    const handleConstruction = () => {
        if (shouldPrintConstruction) {
            handlePrintRefConstruction();
            setShouldPrintConstruction(false);
        }
    };
    //print for ConstructionCheck Letter
    const [shouldPrintConstructionCheck, setShouldPrintConstructionCheck] = useState(false);
    const printRefConstructionCheck = useRef(null);

    const handlePrintRefConstructionCheck = useReactToPrint({
        content: () => printRefConstructionCheck.current,
    });

    const handlePrintConstructionCheck = () => {
        setShouldPrintConstructionCheck(true);
        refetchPrintOutPdf()
    };

    const handleConstructionCheck = () => {
        if (shouldPrintConstructionCheck) {
            handlePrintRefConstructionCheck();
            setShouldPrintConstructionCheck(false);
        }
    };
    //print for JobSold Letter
    const [shouldPrintJobSold, setShouldPrintJobSold] = useState(false);
    const printRefJobSold = useRef(null);

    const handlePrintRefJobSold = useReactToPrint({
        content: () => printRefJobSold.current,
    });

    const handlePrintJobSold = () => {
        setShouldPrintJobSold(true);
        refetchPrintOutPdf()
    };

    const handleJobSold = () => {
        if (shouldPrintJobSold) {
            handlePrintRefJobSold();
            setShouldPrintJobSold(false);
        }
    };
    //print for NoPhone Letter
    const [shouldPrintNoPhone, setShouldPrintNoPhone] = useState(false);
    const printRefNoPhone = useRef(null);

    const handlePrintRefNoPhone = useReactToPrint({
        content: () => printRefNoPhone.current,
    });

    const handlePrintNoPhone = () => {
        setShouldPrintNoPhone(true);
        refetchPrintOutPdf()
    };

    const handleNoPhone = () => {
        if (shouldPrintNoPhone) {
            handlePrintRefNoPhone();
            setShouldPrintNoPhone(false);
        }
    };
    //print for Received Letter
    const [shouldPrintReceived, setShouldPrintReceived] = useState(false);
    const printRefReceived = useRef(null);

    const handlePrintRefReceived = useReactToPrint({
        content: () => printRefReceived.current,
    });

    const handlePrintReceived = () => {
        setShouldPrintReceived(true);
        refetchPrintOutPdf()
    };

    const handleReceived = () => {
        if (shouldPrintReceived) {
            handlePrintRefReceived();
            setShouldPrintReceived(false);
        }
    };
    //print for Payment Letter
    const [shouldPrintPayment, setShouldPrintPayment] = useState(false);
    const printRefPayment = useRef(null);

    const handlePrintRefPayment = useReactToPrint({
        content: () => printRefPayment.current,
    });

    const handlePrintPayment = () => {
        setShouldPrintPayment(true);
        refetchPrintOutPdf()
    };

    const handlePayment = () => {
        if (shouldPrintPayment) {
            handlePrintRefPayment();
            setShouldPrintPayment(false);
        }
    };


    //Multi Print 

    const allDocs = [
        "photoRelease",
        "recoAlready",
        "recoDenial",
        "recoDuplicate",
        "recoJobIn",
        "recoConst",
        "recoSold",
        "recoNoPhone",
        "recoPayment",
        "recoReceived",
    ];

    const [selectedDocs, setSelectedDocs] = useState<string[]>([]);
    const [isPrinting, setIsPrinting] = useState(false);

    const handleCheck = (name: string) => {
        setSelectedDocs(prev =>
            prev.includes(name) ? prev.filter(item => item !== name) : [...prev, name]
        );
    };

    const handleSelectAll = () => {
        if (selectedDocs.length === allDocs.length) {
            setSelectedDocs([]); // unselect all
        } else {
            setSelectedDocs(allDocs); // select all
        }
    };

    // const downloadPDFMulti = async () => {
    //     const content = document.getElementById("pdf-multi-marketing");
    //     if (!content) return;
    //     if (selectedDocs.length === 0) return;
    //     setIsPrinting(true);


    //     const options = {
    //         margin: 0,
    //         filename: "multi-component.pdf",
    //         html2canvas: { scale: 5 },
    //         jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    //     };

    //     try {
    //         const pdf = html2pdf().set(options).from(content);
    //         // Instead of save(), generate a blob URL
    //         const blobUrl = await pdf.output('bloburl');
    //         // Open in new window
    //         window.open(blobUrl, "_blank");
    //     } catch (error) {
    //         console.error(error);
    //     }
    //     finally {
    //         setIsPrinting(false);
    //         setSelectedDocs([])
    //     }
    // };

    const printRefMultiMarketing = useRef<HTMLDivElement>(null);
    const downloadPDFMultiStatic = useReactToPrint({
        content: () => printRefMultiMarketing.current,
        documentTitle: "multi-component",
        onBeforeGetContent: async () => {
            setIsPrinting(true);
            await refetchPrintOutPdf();
        },
        onAfterPrint: () => {
            setIsPrinting(false);
            setSelectedDocs([]);
        },
    });

    const handleDownloadPDFMultiStatic = () => {
        if (!printRefMultiMarketing.current) return;
        if (selectedDocs.length === 0) return;
        downloadPDFMultiStatic();
    };
    return (
        <>
            {/* template show modal code  */}
            <ModalComponent
                modalTitle="Photography Release"
                isVisible={showModalPhotography}
                cancelButton="Cancel"
                onClose={handleClosePhotography}
                buttonText2="Send Email"
                onSave2={() => handleEmailWithTemplate(templateId, modalTitlePopup, fileNamePopup)}
                saveButton={"Download"}
                className="p-2 modal-xl"
                onSave={() => downloadhandlePhotography()}
            >
                <PhotographyRelease printRef={printRefPhotgraphy} onRenderReady={handlePhotgraphy} />
            </ModalComponent>
            <div
                ref={printRefPhotgraphy}
                className="job-card-print"
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {shouldPrintPhotgraphy &&
                    <PhotographyRelease printRef={printRefPhotgraphy} onRenderReady={handlePhotgraphy} />
                }
            </div>
            <ModalComponent
                modalTitle="Reco Already Sold Job Letter"
                isVisible={showModalRecoAlready}
                cancelButton="Cancel"
                onClose={handleCloseRecoAlready}
                buttonText2="Send Email"
                onSave2={() => handleEmailWithTemplate(templateId, modalTitlePopup, fileNamePopup)}
                saveButton={"Download"}
                className="p-2 modal-xl"
                onSave={() => downloadhandlePhotography()}
            >
                <RecoAlreadySoldJob printOutPdfDetails={printOutPdfDetails?.result} />
            </ModalComponent>
            <div
                ref={printRefRecoSold}
                className="job-card-print"
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {printOutPdfDetails && shouldPrintRecoSold &&
                    <RecoAlreadySoldJob printOutPdfDetails={printOutPdfDetails?.result} printRef={printRefRecoSold} onRenderReady={handleRecoSold} />
                }
            </div>

            <ModalComponent
                modalTitle="Reco Denial Letter"
                isVisible={showModalRecoDenial}
                cancelButton="Cancel"
                onClose={handleCloseRecoDenial}
                buttonText2="Send Email"
                onSave2={() => handleEmailWithTemplate(templateId, modalTitlePopup, fileNamePopup)}
                saveButton={"Download"}
                className="p-2 modal-xl"
                onSave={() => downloadhandlePhotography()}
            >
                <RecoDanialLetter printOutPdfDetails={printOutPdfDetails?.result} />
            </ModalComponent>
            <div
                ref={printRefDanial}
                className="job-card-print"
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {printOutPdfDetails && shouldPrintDanial &&
                    <RecoDanialLetter printOutPdfDetails={printOutPdfDetails?.result} printRef={printRefDanial} onRenderReady={handleDanial} />
                }
            </div>

            <ModalComponent
                modalTitle="Reco Duplicate Referral Letter"
                isVisible={showModalRecoDuplicateRef}
                cancelButton="Cancel"
                onClose={handleCloseRecoDuplicateRef}
                buttonText2="Send Email"
                onSave2={() => handleEmailWithTemplate(templateId, modalTitlePopup, fileNamePopup)}
                saveButton={"Download"}
                className="p-2 modal-xl"
                onSave={() => downloadhandlePhotography()}
            >
                <RecoDuplicateReflLetter printOutPdfDetails={printOutPdfDetails?.result} />
            </ModalComponent>
            <div
                ref={printRefDuplicate}
                className="job-card-print"
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {printOutPdfDetails && shouldPrintDuplicate &&
                    <RecoDuplicateReflLetter printOutPdfDetails={printOutPdfDetails?.result} printRef={printRefDuplicate} onRenderReady={handleDuplicate} />
                }
            </div>
            <ModalComponent
                modalTitle="Reco Job In Construction Letter with Check Requisition"
                isVisible={showModalJobInWithCheck}
                cancelButton="Cancel"
                onClose={handleCloseRecoJobInWithCheck}
                buttonText2="Send Email"
                onSave2={() => handleEmailWithTemplate(templateId, modalTitlePopup, fileNamePopup)}
                saveButton={"Download"}
                className="p-2 modal-xl"
                onSave={() => downloadhandlePhotography()}
            >
                <RecoJobInConstructionWithCheck printOutPdfDetails={printOutPdfDetails?.result} />
            </ModalComponent>
            <div
                ref={printRefConstructionCheck}
                className="job-card-print"
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {printOutPdfDetails && shouldPrintConstructionCheck &&
                    <RecoJobInConstructionWithCheck printOutPdfDetails={printOutPdfDetails?.result} printRef={printRefConstructionCheck} onRenderReady={handleConstructionCheck} />
                }
            </div>
            <ModalComponent
                modalTitle="Reco Job In Construction Letter"
                isVisible={showModalJobInConst}
                cancelButton="Cancel"
                onClose={handleCloseRecoJobInConst}
                buttonText2="Send Email"
                onSave2={() => handleEmailWithTemplate(templateId, modalTitlePopup, fileNamePopup)}
                saveButton={"Download"}
                className="p-2 modal-xl"
                onSave={() => downloadhandlePhotography()}
            >
                <RecoJobInConstruction printOutPdfDetails={printOutPdfDetails?.result} />
            </ModalComponent>
            <div
                ref={printRefConstruction}
                className="job-card-print"
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {printOutPdfDetails && shouldPrintConstruction &&
                    <RecoJobInConstruction printOutPdfDetails={printOutPdfDetails?.result} printRef={printRefConstruction} onRenderReady={handleConstruction} />
                }
            </div>
            <ModalComponent
                modalTitle="Reco Job Sold Letter"
                isVisible={showModalRecoJobSold}
                cancelButton="Cancel"
                onClose={handleCloseRecoJobSold}
                buttonText2="Send Email"
                onSave2={() => handleEmailWithTemplate(templateId, modalTitlePopup, fileNamePopup)}
                saveButton={"Download"}
                className="p-2 modal-xl"
                onSave={() => downloadhandlePhotography()}
            >
                <RecoJobSoldLetter printOutPdfDetails={printOutPdfDetails?.result} />
            </ModalComponent>
            <div
                ref={printRefJobSold}
                className="job-card-print"
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {printOutPdfDetails && shouldPrintJobSold &&
                    <RecoJobSoldLetter printOutPdfDetails={printOutPdfDetails?.result} printRef={printRefJobSold} onRenderReady={handleJobSold} />
                }
            </div>
            <ModalComponent
                modalTitle="Reco No Phone Number Letter"
                isVisible={showModalRecoNoPhone}
                cancelButton="Cancel"
                onClose={handleCloseRecoNoPhone}
                buttonText2="Send Email"
                onSave2={() => handleEmailWithTemplate(templateId, modalTitlePopup, fileNamePopup)}
                saveButton={"Download"}
                className="p-2 modal-xl"
                onSave={() => downloadhandlePhotography()}
            >
                <RecoNoPhoneNumber printOutPdfDetails={printOutPdfDetails?.result} />
            </ModalComponent>
            <div
                ref={printRefNoPhone}
                className="job-card-print"
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {printOutPdfDetails && shouldPrintNoPhone &&
                    <RecoNoPhoneNumber printOutPdfDetails={printOutPdfDetails?.result} printRef={printRefNoPhone} onRenderReady={handleNoPhone} />
                }
            </div>
            <ModalComponent
                modalTitle="Reco Payment Letter"
                isVisible={showModalRecoPaymentLetter}
                cancelButton="Cancel"
                onClose={handleCloseRecoPayLetter}
                buttonText2="Send Email"
                onSave2={() => handleEmailWithTemplate(templateId, modalTitlePopup, fileNamePopup)}
                saveButton={"Download"}
                className="p-2 modal-xl"
                onSave={() => downloadhandlePhotography()}
            >
                <RecoPaymentLetter printOutPdfDetails={printOutPdfDetails?.result} />
            </ModalComponent>
            <div
                ref={printRefPayment}
                className="job-card-print"
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {printOutPdfDetails && shouldPrintPayment &&
                    <RecoPaymentLetter printOutPdfDetails={printOutPdfDetails?.result} printRef={printRefPayment} onRenderReady={handlePayment} />
                }
            </div>
            <ModalComponent
                modalTitle="Reco Received Letter"
                isVisible={showModalRecoReceivedLetter}
                cancelButton="Cancel"
                onClose={handleCloseRecoReceiveLetter}
                buttonText2="Send Email"
                onSave2={() => handleEmailWithTemplate(templateId, modalTitlePopup, fileNamePopup)}
                saveButton={"Download"}
                className="p-2 modal-xl"
                onSave={() => downloadhandlePhotography()}
            >
                <RecoReceiveLetter printOutPdfDetails={printOutPdfDetails?.result} />
            </ModalComponent>
            <div
                ref={printRefReceived}
                className="job-card-print"
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {printOutPdfDetails && shouldPrintReceived &&
                    <RecoReceiveLetter printOutPdfDetails={printOutPdfDetails?.result} printRef={printRefReceived} onRenderReady={handleReceived} />
                }
            </div>

            {/* multi print  */}
            {printOutPdfDetails?.result &&
                <div style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}>
                    <div id="pdf-multi-marketing" ref={printRefMultiMarketing}>
                        {selectedDocs.includes("photoRelease") && (
                            <PhotographyRelease printOutPdfDetails={printOutPdfDetails?.result} />
                        )}
                        {selectedDocs.includes("recoAlready") && (
                            <RecoAlreadySoldJob printOutPdfDetails={printOutPdfDetails?.result} />
                        )}
                        {selectedDocs.includes("recoDenial") && (
                            <RecoDanialLetter printOutPdfDetails={printOutPdfDetails?.result} />
                        )}
                        {selectedDocs.includes("recoDuplicate") && (
                            <RecoDuplicateReflLetter printOutPdfDetails={printOutPdfDetails?.result} />
                        )}
                        {selectedDocs.includes("recoJobIn") && (
                            <RecoJobInConstruction printOutPdfDetails={printOutPdfDetails?.result} />
                        )}
                        {selectedDocs.includes("recoConst") && (
                            <RecoJobInConstructionWithCheck printOutPdfDetails={printOutPdfDetails?.result} />
                        )}
                        {selectedDocs.includes("recoSold") && (
                            <RecoJobSoldLetter printOutPdfDetails={printOutPdfDetails?.result} />
                        )}
                        {selectedDocs.includes("recoNoPhone") && (
                            <RecoNoPhoneNumber printOutPdfDetails={printOutPdfDetails?.result} />
                        )}
                        {selectedDocs.includes("recoPayment") && (
                            <RecoPaymentLetter printOutPdfDetails={printOutPdfDetails?.result} />
                        )}
                        {selectedDocs.includes("recoReceived") && (
                            <RecoReceiveLetter printOutPdfDetails={printOutPdfDetails?.result} />
                        )}
                    </div>
                </div>
            }


            {/* //email show modal code  */}
            <ModalComponent
                buttonText="Send"
                modalTitle={modalTitlePopup}
                onClose={handleClose}
                onSave={handleSave}
                isVisible={showEmailModal}
                cancelButton="Cancel"
                saveButton="Send"
            >
                <>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="input-label">
                                <TextField
                                    label="Subject"
                                    required
                                    type="text"
                                    {...formik.getFieldProps("Subject")}
                                />
                            </div>
                            {formik.touched.Subject && formik.errors.Subject && (
                                <>
                                    <div className="error">{formik.errors.Subject}</div>
                                </>
                            )}
                            <div className="col-md-12">
                                <div className="d-flex justify-content-between align-items-center">
                                    <label>Internal Users</label>
                                    <button
                                        className="btn btn-primary mb-1 mt-1 fs-11"
                                        onClick={handleGetTeamMembers}
                                    >
                                        Get Team Members
                                    </button>
                                </div>
                                <Select
                                    isMulti={true}
                                    styles={customStyles}
                                    className="select multi-select"
                                    options={
                                        projectLookups?.result?.ActiveUserEmail?.map(
                                            (option: any) => ({
                                                label: option?.value,
                                                value: option?.id,
                                            })
                                        ) || []
                                    }
                                    value={selectValues}
                                    onChange={(newValue: any) => handleChange(newValue)}
                                />
                            </div>
                            {Array.isArray(formik.errors.InternalEmailAddresses) &&
                                formik.errors.InternalEmailAddresses.map((error, index) => {
                                    const fieldTouched =
                                        formik.touched.InternalEmailAddresses?.[index];
                                    const isObjectError =
                                        typeof error === "object" && error !== null;

                                    return (
                                        <div key={index}>
                                            {isObjectError && fieldTouched?.id && error.id && (
                                                <div className="error">{error.id}</div>
                                            )}
                                            {isObjectError && fieldTouched?.value && error.value && (
                                                <div className="error">{error.value}</div>
                                            )}
                                        </div>
                                    );
                                })}
                            <div className="col-md-12">
                                <div className="d-flex justify-content-between">
                                    <label className="input-label">External Users</label>
                                </div>
                                <div className="email-input-container">
                                    <div className="badges-container">
                                        {formik.values.ExternalEmailAddresses[0] !== "" ? (
                                            formik.values.ExternalEmailAddresses.map(
                                                (email: string, index: number) => (
                                                    <span
                                                        key={index}
                                                        className="badge badge-pill badge-primary me-2"
                                                    >
                                                        {email}{" "}
                                                        <button
                                                            type="button"
                                                            className="btn-close ms-1"
                                                            onClick={() => removeEmail(email)}
                                                        >
                                                            &times;
                                                        </button>
                                                    </span>
                                                )
                                            )
                                        ) : (
                                            <span className="text-muted"></span>
                                        )}
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="Enter email and Press enter"
                                            value={inputValue}
                                            onChange={(e) => setInputValue(e.target.value)}
                                            onKeyDown={handleKeyDown}
                                        />
                                    </div>
                                    {formik.errors.ExternalEmailAddresses && (
                                        <div className="text-danger">
                                            {formik.errors.ExternalEmailAddresses}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-12">
                                <RichTextEditor
                                    value={formik.values.Body}
                                    name="Message"
                                    onChange={(value: any) => formik.setFieldValue("Body", value)}
                                />
                            </div>

                            <label className="input-label mt-2"> Attachments</label>
                            <div className="br-gray p-2 bg-lightGray">
                                <p>{formik.values.Attachments[0]?.name}</p>
                            </div>
                        </div>
                    </div>
                </>
            </ModalComponent>


            {/* table show code  */}

            <div className="row">
                <div className="col-md-7">
                    <div className="card">
                        <div className="card-body card-css">
                            <h6>
                                The Link Below represents printouts available in different
                                places in AFD. Use this page to quickly locate and print
                                printouts of all kinds.
                            </h6>
                            {selectedDocs.length > 0 && (
                                <div className="d-flex align-items-center justify-content-end mt-3">
                                    <button className="btn btn-primary" onClick={handleDownloadPDFMultiStatic}>
                                        {isPrinting ? "Printing....." : "Print"}
                                    </button>
                                </div>
                            )}
                            <div className="table-responsive mt-3">
                                <table className="table datanew dataTable no-footer table-hover">
                                    <thead>
                                        <tr>
                                            <th>
                                                <label className="checkboxs mb-3">
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedDocs.length === allDocs.length}
                                                        onChange={handleSelectAll}
                                                        className='cursor-pointer'
                                                    />
                                                    <span className="checkmarks" />
                                                </label>
                                            </th>
                                            <th>Name</th>
                                            <th>TYPE</th>
                                            <th>Print</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <label className="checkboxs mb-3">
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedDocs.includes("photoRelease")}
                                                        onChange={() => handleCheck("photoRelease")}
                                                        className='cursor-pointer'
                                                    />
                                                    <span className="checkmarks" />
                                                </label>
                                            </td>
                                            <td
                                                className="text-decoration-underline color-red cursor-pointer mb-0"
                                                onClick={() => handleShowModalPhotography("PhotographyRelease", "Photography Release", "PhotographyRelease.docx")}

                                            >
                                                Photography Release
                                            </td>
                                            <td>Lead</td>
                                            <td className="cursor-pointer"
                                                onClick={handlePrintPhotgraphy}>
                                                {!shouldPrintPhotgraphy ?
                                                    <button
                                                        className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                        data-tooltip-id="my-tooltip-5">
                                                        <ImageWithBasePath
                                                            src="assets/img/printIcon.svg"
                                                            className=""
                                                            alt="Logo"
                                                            width={16}
                                                            height={16}
                                                        />
                                                    </button>
                                                    :
                                                    <div className="spinnerPdf" />
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label className="checkboxs mb-3">
                                                    <input
                                                        className='cursor-pointer'
                                                        type="checkbox"
                                                        checked={selectedDocs.includes("recoAlready")}
                                                        onChange={() => handleCheck("recoAlready")}
                                                    />
                                                    <span className="checkmarks" />
                                                </label>
                                            </td>
                                            <td
                                                className="text-decoration-underline color-red cursor-pointer mb-0"
                                                onClick={() => handleShowModalRecoAlready("RecoAlreadySoldJobLetter", "Reco Already Sold Job Letter", "RecoAlreadySoldJob.docx")}
                                            >
                                                Reco Already Sold Job Letter
                                            </td>
                                            <td>Lead</td>
                                            <td className="cursor-pointer"
                                                onClick={handlePrintRecoSold}>
                                                {!shouldPrintRecoSold ?
                                                    <button
                                                        className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                        data-tooltip-id="my-tooltip-5">
                                                        <ImageWithBasePath
                                                            src="assets/img/printIcon.svg"
                                                            className=""
                                                            alt="Logo"
                                                            width={16}
                                                            height={16}
                                                        />
                                                    </button>
                                                    :
                                                    <div className="spinnerPdf" />
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label className="checkboxs mb-3">
                                                    <input
                                                        className='cursor-pointer'
                                                        type="checkbox"
                                                        checked={selectedDocs.includes("recoDenial")}
                                                        onChange={() => handleCheck("recoDenial")}
                                                    />
                                                    <span className="checkmarks" />
                                                </label>
                                            </td>
                                            <td
                                                className="text-decoration-underline color-red cursor-pointer mb-0"
                                                onClick={() => handleShowModalRecoDenial("RecoDenialLetter", "Reco Denial Letter", "RecoDenialLetter.docx")}
                                            >
                                                Reco Denial Letter
                                            </td>
                                            <td>Lead</td>
                                            <td className="cursor-pointer"
                                                onClick={handlePrintDanial}>
                                                {!shouldPrintDanial ?
                                                    <button
                                                        className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                        data-tooltip-id="my-tooltip-5">
                                                        <ImageWithBasePath
                                                            src="assets/img/printIcon.svg"
                                                            className=""
                                                            alt="Logo"
                                                            width={16}
                                                            height={16}
                                                        />
                                                    </button>
                                                    :
                                                    <div className="spinnerPdf" />
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label className="checkboxs mb-3">
                                                    <input
                                                        className='cursor-pointer'
                                                        type="checkbox"
                                                        checked={selectedDocs.includes("recoDuplicate")}
                                                        onChange={() => handleCheck("recoDuplicate")}
                                                    />
                                                    <span className="checkmarks" />
                                                </label>
                                            </td>
                                            <td
                                                className="text-decoration-underline color-red cursor-pointer mb-0"
                                                onClick={() => handleShowModalRecoDuplicateRef("RecoDuplicateReferralLetter", "Reco Duplicate Referral Letter", "RecoDuplicateReferralLetter.docx")}
                                            >
                                                Reco Duplicate Referral Letter
                                            </td>
                                            <td>Lead</td>
                                            <td className="cursor-pointer"
                                                onClick={handlePrintDuplicate}>
                                                {!shouldPrintDuplicate ?
                                                    <button
                                                        className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                        data-tooltip-id="my-tooltip-5">
                                                        <ImageWithBasePath
                                                            src="assets/img/printIcon.svg"
                                                            className=""
                                                            alt="Logo"
                                                            width={16}
                                                            height={16}
                                                        />
                                                    </button>
                                                    :
                                                    <div className="spinnerPdf" />
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label className="checkboxs mb-3">
                                                    <input
                                                        className='cursor-pointer'
                                                        type="checkbox"
                                                        checked={selectedDocs.includes("recoJobIn")}
                                                        onChange={() => handleCheck("recoJobIn")}
                                                    />
                                                    <span className="checkmarks" />
                                                </label>
                                            </td>
                                            <td
                                                className="text-decoration-underline color-red cursor-pointer mb-0"
                                                onClick={() => handleShowModalRecoJobIn("RecoJobInConstructionLetter", "Reco Job In Construction Letter", "RecoJobInConstructionLetter.docx")}
                                            >
                                                Reco Job In Construction Letter
                                            </td>
                                            <td>Lead</td>
                                            <td className="cursor-pointer"
                                                onClick={handlePrintConstruction}>
                                                {!shouldPrintConstruction ?
                                                    <button
                                                        className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                        data-tooltip-id="my-tooltip-5">
                                                        <ImageWithBasePath
                                                            src="assets/img/printIcon.svg"
                                                            className=""
                                                            alt="Logo"
                                                            width={16}
                                                            height={16}
                                                        />
                                                    </button>
                                                    :
                                                    <div className="spinnerPdf" />
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label className="checkboxs mb-3">
                                                    <input
                                                        className='cursor-pointer'
                                                        type="checkbox"
                                                        checked={selectedDocs.includes("recoConst")}
                                                        onChange={() => handleCheck("recoConst")}
                                                    />
                                                    <span className="checkmarks" />
                                                </label>
                                            </td>
                                            <td
                                                className="text-decoration-underline color-red cursor-pointer mb-0"
                                                onClick={() => handleShowModalRecoJobInWithCheck("RecoJobInConstructionLetterwithCheckRequisition", "Reco Job In Construction Letter with Check Requisition", "RecoJobInConstructionLetter(withCheckRequisition).docx")}
                                            >
                                                Reco Job In Construction Letter with Check Requisition
                                            </td>
                                            <td>Lead</td>
                                            <td className="cursor-pointer"
                                                onClick={handlePrintConstructionCheck}>
                                                {!shouldPrintConstructionCheck ?
                                                    <button
                                                        className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                        data-tooltip-id="my-tooltip-5">
                                                        <ImageWithBasePath
                                                            src="assets/img/printIcon.svg"
                                                            className=""
                                                            alt="Logo"
                                                            width={16}
                                                            height={16}
                                                        />
                                                    </button>
                                                    :
                                                    <div className="spinnerPdf" />
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label className="checkboxs mb-3">
                                                    <input
                                                        className='cursor-pointer'
                                                        type="checkbox"
                                                        checked={selectedDocs.includes("recoSold")}
                                                        onChange={() => handleCheck("recoSold")}
                                                    />
                                                    <span className="checkmarks" />
                                                </label>
                                            </td>
                                            <td
                                                className="text-decoration-underline color-red cursor-pointer mb-0"
                                                onClick={() => handleShowModalRecoJobSold("RecoJobSoldLetter", "Reco Job Sold Letter", "RecoJobSoldLetter.docx")}
                                            >
                                                Reco Job Sold Letter
                                            </td>
                                            <td>Lead</td>
                                            <td className="cursor-pointer"
                                                onClick={handlePrintJobSold}>
                                                {!shouldPrintJobSold ?
                                                    <button
                                                        className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                        data-tooltip-id="my-tooltip-5">
                                                        <ImageWithBasePath
                                                            src="assets/img/printIcon.svg"
                                                            className=""
                                                            alt="Logo"
                                                            width={16}
                                                            height={16}
                                                        />
                                                    </button>
                                                    :
                                                    <div className="spinnerPdf" />
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label className="checkboxs mb-3">
                                                    <input
                                                        className='cursor-pointer'
                                                        type="checkbox"
                                                        checked={selectedDocs.includes("recoNoPhone")}
                                                        onChange={() => handleCheck("recoNoPhone")}
                                                    />
                                                    <span className="checkmarks" />
                                                </label>
                                            </td>
                                            <td
                                                className="text-decoration-underline color-red cursor-pointer mb-0"
                                                onClick={() => handleShowModalRecoNoPhone("RecoNoPhoneNumberLetter", "Reco No Phone Number Letter", "RecoNoPhoneNumberLetter.docx")}
                                            >
                                                Reco No Phone Number Letter
                                            </td>
                                            <td>Lead</td>
                                            <td className="cursor-pointer"
                                                onClick={handlePrintNoPhone}>
                                                {!shouldPrintNoPhone ?
                                                    <button
                                                        className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                        data-tooltip-id="my-tooltip-5">
                                                        <ImageWithBasePath
                                                            src="assets/img/printIcon.svg"
                                                            className=""
                                                            alt="Logo"
                                                            width={16}
                                                            height={16}
                                                        />
                                                    </button>
                                                    :
                                                    <div className="spinnerPdf" />
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label className="checkboxs mb-3">
                                                    <input
                                                        className='cursor-pointer'
                                                        type="checkbox"
                                                        checked={selectedDocs.includes("recoPayment")}
                                                        onChange={() => handleCheck("recoPayment")}
                                                    />
                                                    <span className="checkmarks" />
                                                </label>
                                            </td>
                                            <td
                                                className="text-decoration-underline color-red cursor-pointer mb-0"
                                                onClick={() => handleShowModalRecoPayLetter("RecoPaymentLetter", "Reco Payment Letter", "RecoPaymentLetter.docx")}
                                            >
                                                Reco Payment Letter
                                            </td>
                                            <td>Lead</td>
                                            <td className="cursor-pointer"
                                                onClick={handlePrintPayment}>
                                                {!shouldPrintPayment ?
                                                    <button
                                                        className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                        data-tooltip-id="my-tooltip-5">
                                                        <ImageWithBasePath
                                                            src="assets/img/printIcon.svg"
                                                            className=""
                                                            alt="Logo"
                                                            width={16}
                                                            height={16}
                                                        />
                                                    </button>
                                                    :
                                                    <div className="spinnerPdf" />
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label className="checkboxs mb-3">
                                                    <input
                                                        className='cursor-pointer'
                                                        type="checkbox"
                                                        checked={selectedDocs.includes("recoReceived")}
                                                        onChange={() => handleCheck("recoReceived")}
                                                    />
                                                    <span className="checkmarks" />
                                                </label>
                                            </td>
                                            <td
                                                className="text-decoration-underline color-red cursor-pointer mb-0"
                                                onClick={() => handleShowModalRecoRecLetter("RecoReceivedLetter", "Reco Received Letter", "RecoReceivedLetter.docx")}
                                            >
                                                Reco Received Letter
                                            </td>
                                            <td>Lead</td>
                                            <td className="cursor-pointer"
                                                onClick={handlePrintReceived}>
                                                {!shouldPrintReceived ?
                                                    <button
                                                        className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                        data-tooltip-id="my-tooltip-5">
                                                        <ImageWithBasePath
                                                            src="assets/img/printIcon.svg"
                                                            className=""
                                                            alt="Logo"
                                                            width={16}
                                                            height={16}
                                                        />
                                                    </button>
                                                    :
                                                    <div className="spinnerPdf" />
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MarketingTemplates